/* istanbul ignore file */
import { createContext, useContext } from 'react';
import { ActionDispatchContext } from '../typings/main_context_reducer';

export const MainContext = createContext([] as any);

export const useMainContext = (): ActionDispatchContext =>
  useContext(MainContext);
